import VueJwtDecode from "vue-jwt-decode";
import { crono } from "vue-crono";

import LABEL from "../../utils/label";
import { SISR_TOKEN } from "../../utils/access/constants";
import { makeToast, TOAST_RESULT } from "../../Toast";

import { nameRoutes } from "../../router/nameRoutes";
import { logout } from "../../utils/user/api";

import { layoutMixin } from "./layout";

const MINUTES_BEFORE_EXP_ALERT = 2;

export const baseMixin = {
  mixins: [layoutMixin, crono],
  data() {
    return { loader: { page: true } };
  },
  methods: {
    setAll: async function () {
      await this.$store.dispatch("UserDetails/makeUserDetails");
      this.loader.page = false;
    },

    logoutRequest: async function () {
      this.loader.page = true;
      await logout();
      localStorage.removeItem(SISR_TOKEN);
      this.$router.push({ name: nameRoutes.LOGIN });
      this.loader.page = false;
    },
    alert: function () {
      this.$cron.stop("alert");
      makeToast(TOAST_RESULT.WARN, LABEL.TOAST.SESSION_EXPIRE_WARNING);
    },
  },
  created() {
    this.setAll();
  },
  ...(localStorage.getItem(SISR_TOKEN)
    ? {
        cron: {
          time:
            new Date(
              parseInt(
                VueJwtDecode.decode(localStorage.getItem(SISR_TOKEN)).exp
              ) * 1000
            ).getTime() -
            new Date().getTime() -
            MINUTES_BEFORE_EXP_ALERT * 60 * 1000,
          method: "alert",
        },
      }
    : null),
};
